import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let PublicationFields = {
    'main_author': {
        display: {
            name: '主要作者',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'main_author',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'publisher': {
        display: {
            name: '出版者',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'publisher',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'publish_date': {
        display: {
            name: '出版日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'publish_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'edition': {
        display: {
            name: '版次',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'edition',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'language': {
        display: {
            name: '語言',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'language',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multiple-select-as-is',
            options: {
                type: 'fixed',
                list: ['中文','英文','日文'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'color': {
        display: {
            name: '色彩',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'color',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['彩色','黑白'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'format_size_length': {
        display: {
            name: '尺寸-長',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_length',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'format_size_width': {
        display: {
            name: '尺寸-寬',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_width',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'format_size_unit': {
        display: {
            name: '尺寸-單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_unit',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['公分','公尺'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'quantity': {
        display: {
            name: '數量',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'quantity',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'page_number': {
        display: {
            name: '頁數',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'page_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'gpn': {
        display: {
            name: 'GPN',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'gpn',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'isbn': {
        display: {
            name: 'ISBN',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'isbn',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'price': {
        display: {
            name: '定價',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'price',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'issuer': {
        display: {
            name: '發行人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'issuer',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'main_planner': {
        display: {
            name: '總策畫',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'main_planner',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'executive_unit': {
        display: {
            name: '執行單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'executive_unit',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
}

let Publication = (front_back) => {

    let fields = 
    [
        PublicationFields['main_author'],
        PublicationFields['publisher'],
        PublicationFields['publish_date'],
        PublicationFields['edition'],
        PublicationFields['language'],
        PublicationFields['color'],
        PublicationFields['format_size_length'],
        PublicationFields['format_size_width'],
        PublicationFields['format_size_unit'],
        PublicationFields['quantity'],
        PublicationFields['page_number'],
        PublicationFields['gpn'],
        PublicationFields['isbn'],
        PublicationFields['price'],
        PublicationFields['issuer'],
        PublicationFields['main_planner'],
        PublicationFields['executive_unit'],
    ]

    return {
        name: '出版品資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('publication', front_back),
        ForestryData('publication', front_back),
        Publication(front_back), 
        Rights('publication', front_back), 
        PhysicalObject('publication', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '出版品',
        type: 'group',
        fields
    }    
}
  